import { useFormStore } from '@/stores/form'

export default function () {
  const formStore = useFormStore()

  formStore.form.setFieldValue('vistReason', 'Truck Drivers - سائقي الشاحنات')
}
